import { PLATFORM_TYPES } from '../constants/platforms';

export type IRedeemCodeFormat = {
    readonly groups: number,
    readonly characters: number,
    /* TODO: Remove after ~2.6.0 is not supported */
    readonly count?: number,
    readonly length?: number
};

/* V2 Types */
export enum PLATFORM_CODE {
    UPLAY = 'uplay',
    PS4 = 'ps4',
    XONE = 'xone',
    STEAM = 'steam',
    SWITCH = 'switch',
    PS5 = 'ps5',
    XSX = 'xsx',
    EPIC = 'epic'
}

type REDEEM_API_PLATFORM_TYPES =
    PLATFORM_TYPES.PC
    | PLATFORM_TYPES.PS4
    | PLATFORM_TYPES.PS5
    | PLATFORM_TYPES.XONE
    | PLATFORM_TYPES.XSX
    | PLATFORM_TYPES.EPIC
    | PLATFORM_TYPES.SWITCH
    | PLATFORM_TYPES.STEAM;

export const PLATFORM_CODE_TO_TYPE: { [key in PLATFORM_CODE]: PLATFORM_TYPES } = {
    [PLATFORM_CODE.UPLAY]: PLATFORM_TYPES.PC,
    [PLATFORM_CODE.PS4]: PLATFORM_TYPES.PS4,
    [PLATFORM_CODE.PS5]: PLATFORM_TYPES.PS5,
    [PLATFORM_CODE.XONE]: PLATFORM_TYPES.XONE,
    [PLATFORM_CODE.XSX]: PLATFORM_TYPES.XSX,
    [PLATFORM_CODE.EPIC]: PLATFORM_TYPES.EPIC,
    [PLATFORM_CODE.SWITCH]: PLATFORM_TYPES.SWITCH,
    [PLATFORM_CODE.STEAM]: PLATFORM_TYPES.STEAM
};

export const PLATFORM_TYPE_TO_CODE: { [key in REDEEM_API_PLATFORM_TYPES]: PLATFORM_CODE } = {
    [PLATFORM_TYPES.PC]: PLATFORM_CODE.UPLAY,
    [PLATFORM_TYPES.PS4]: PLATFORM_CODE.PS4,
    [PLATFORM_TYPES.PS5]: PLATFORM_CODE.PS5,
    [PLATFORM_TYPES.XONE]: PLATFORM_CODE.XONE,
    [PLATFORM_TYPES.XSX]: PLATFORM_CODE.XSX,
    [PLATFORM_TYPES.EPIC]: PLATFORM_CODE.EPIC,
    [PLATFORM_TYPES.SWITCH]: PLATFORM_CODE.SWITCH,
    [PLATFORM_TYPES.STEAM]: PLATFORM_CODE.STEAM
};

export type Benefit = {
    readonly benefitId: string, // UUID identifier of the benefit that was claimed
    readonly name: string, // Name of the benefit that was claimed
    readonly platformType: PLATFORM_CODE // Platform on which the benefit was activated. Can be NULL
};

export type BenefitDetails = Benefit & {
    readonly code: string, // The code that was redeemed. Can be NULL
    readonly createdAt: string, // UTC date when benefit has been claimed (format YYYY-MM-DDTHH:mm:ss.SSSZ)
    readonly lastModifiedAt: string // UTC date when the benefit status was last updated (format YYYY-MM-DDTHH:mm:ss.SSSZ)
};

export type RedeemServiceResponse<T> = T | RedeemServiceError;

export type BenefitsResponse = {
    readonly benefits: [BenefitDetails]
};

export type SelectBenefitResponse = {
    // readonly selectableBenefitsCount: number, maxSelectableBenefits now
    readonly selectableBenefits: [Benefit]
};

export type RedeemServiceError = {
    readonly errorCode: number,
    readonly message: string,
    readonly httpCode: number,
    readonly errorContext: string,
    readonly transactionTime?: string,
    readonly transactionId?: string
};
